export function displayCareConsoleArt() {
  console.log(
    "%cWelsys — Kenya DHA/SHA-compliant Hospital Management System (outpatient & inpatient)",
    "color: #009640; font-weight: bold;",
  );
}
